<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from './stores/auth-store'
import { useUserStore } from './stores/user-store'

const authStore = useAuthStore()
const userStore = useUserStore()

onMounted(async () => {
  // Cargar permisos desde localStorage al iniciar
  authStore.loadPermissionsFromStorage()

  // Si hay token, cargar datos del usuario al iniciar la app
  if (authStore.isAuthenticated) {
    await authStore.fetchCurrentUser()
    // También cargar en user-store para que los componentes que lo usan tengan los datos
    await userStore.fetchCurrentUser()
  }
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}

/* Hide Vuestic devtools button */
.va-open-devtools-button {
  display: none !important;
}
</style>
